module.exports = __webpack_public_path__ + "img/NZ.a1c43634.png";